interface Props {
  reference: string;
}

export function OrderConfirmed({ reference }: Props) {
  return (
    <div
      className="w-full rounded-md border border-success/30 p-5 text-center shadow-card animate-pop-in"
      style={{ backgroundColor: '#F0FFF4' }}
    >
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-success/15">
        <svg width="34" height="34" viewBox="0 0 52 52">
          <circle
            cx="26"
            cy="26"
            r="24"
            fill="none"
            stroke="#22C55E"
            strokeWidth="2.5"
            opacity="0.35"
          />
          <path
            d="M14 27l8 8 16-16"
            fill="none"
            stroke="#22C55E"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="48"
            className="animate-check-draw"
          />
        </svg>
      </div>

      <p className="mt-3 text-sm font-bold text-primary">Order confirmed!</p>
      <p className="mt-1 text-xs text-mid">Thank you — a confirmation is on its way.</p>
      <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-semibold text-primary ring-1 ring-success/20">
        <span className="text-mid">Ref</span>
        <span className="font-mono">{reference}</span>
      </div>
    </div>
  );
}

export default OrderConfirmed;
